/** Filtro de período reutilizável: atalhos, de/até personalizado e ◀ ▶. */
import { useState } from "react";
import { todayIso } from "@/lib/format";
import { makePeriod, periodLabel, PRESETS, shiftPeriod, type Period, type PresetKey } from "@/lib/period";

export function usePeriod(initial: PresetKey = "mes"): [Period, (p: Period) => void] {
  return useState<Period>(() => makePeriod(initial, todayIso()));
}

export function PeriodPicker({ value, onChange, presets }: { value: Period; onChange: (p: Period) => void; presets?: PresetKey[] }): JSX.Element {
  const list = presets ? PRESETS.filter((p) => presets.includes(p.key) || p.key === "personalizado") : PRESETS;
  return (
    <div className="period row nowrap">
      <button className="btn small" title="Período anterior" onClick={() => onChange(shiftPeriod(value, -1))}>◀</button>
      <select className="input" value={value.preset} onChange={(e) => {
        const k = e.target.value as PresetKey;
        onChange(k === "personalizado" ? { ...value, preset: k } : makePeriod(k, todayIso()));
      }}>
        {value.preset === "outro" && <option value="outro">{periodLabel(value)}</option>}
        {list.map((p) => <option key={p.key} value={p.key}>{p.label}</option>)}
      </select>
      {value.preset === "personalizado" ? (
        <>
          <input type="date" className="input" value={value.from} onChange={(e) => e.target.value && onChange({ ...value, from: e.target.value })} />
          <span className="muted small">até</span>
          <input type="date" className="input" value={value.to} onChange={(e) => e.target.value && onChange({ ...value, to: e.target.value })} />
        </>
      ) : <strong className="period-label">{periodLabel(value)}</strong>}
      <button className="btn small" title="Próximo período" onClick={() => onChange(shiftPeriod(value, 1))}>▶</button>
    </div>
  );
}
